var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 19 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-type1/envelope") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Supervisor-desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.800000, -3.000000)",
    fill: "#73818F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-type1/envelope"
  }, /*#__PURE__*/React.createElement("g", {
    id: "envelope-closed",
    transform: "translate(1.615385, 3.230769)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "17.7692308 9.80244755 17.7692308 3.12062937 12.956625 6.46153846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,1.46853147 L8.31346154,7.23986014 C8.47052885,7.35 8.66916346,7.41608392 8.88461538,7.41608392 C9.10006731,7.41608392 9.29870192,7.35 9.45830769,7.23839161 L9.45576923,7.23986014 L17.7692308,1.46853147 L17.7692308,0 L0,0 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "1.61538462 6.3513986 1.61538462 13.0332168 6.42799038 9.69230769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9278846,11.527972 C11.5350577,11.8031748 11.0384712,11.9685315 10.5,11.9685315 C9.96152885,11.9685315 9.46494231,11.8028811 9.06608654,11.5238601 L9.07211538,11.527972 L7.61789423,10.5182098 L1.61538462,14.6853147 L1.61538462,16.1538462 L19.3846154,16.1538462 L19.3846154,14.6853147 L13.3821058,10.5182098 L11.9278846,11.527972 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2a012c7c0605ed406a3694209cc240d6.svg";
export { ForwardRef as ReactComponent };